import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'

import {
  createUrl,
  getQueryParams,
} from '../../../../core/utils/services/queryParams'

import { BOOLEAN_TYPES, DEFAULT_PAGE } from '../../../../common/constants'

const MenuIsExampleFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { isExample } = getQueryParams(search)

  const handleChange = useCallback(
    isExample =>
      history.push(
        createUrl(pathname, search, {
          isExample,
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item label="Is example">
      <Select
        style={{ width: '100%' }}
        value={isExample?.toString()}
        onChange={handleChange}
        allowClear
      >
        {map(BOOLEAN_TYPES, ({ name, value }) => (
          <Select.Option key={value} value={value?.toString()}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default MenuIsExampleFilter
